import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import AdminHeaderTab from '../../../Components/headerTab/AdminHeaderTab'
import { Spin, Table, Typography, message } from 'antd'
import { DataManagementAPI } from '../../../API/admin/DataManagementAPI';
import TableEmptyContent from '../../../Components/TableEmptyContent/TableEmptyContent';
import "./dataManagement.css"
import { EMPLOYEE_COLUMNS_HEAD } from './DataManagementUtils';
const { Text } = Typography;

function DataManagement() {
    const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = useState(false);
    const [tableData, setTableData] = useState([])

    async function loadTableData() {
        setSpinning(true)
        await DataManagementAPI.getTableList()
            .then(res => {
                if (res.data.status === true) {
                    setTableData(res.data?.truncate_value)
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(() => messageToast('error', "Internal Server Error"))
            .finally(() => setSpinning(false))
    }

    useEffect(() => {
        loadTableData()
    }, [])

    const messageToast = (type, message) => {
        messageApi.open({
            type: type,
            content: message,
            duration: 6,
        });
    };

    async function confirmDelete(ele) {
        setSpinning(true)
        const bodyData = {
            "truncate_value": [
                {
                    "table": ele?.table,
                    "value": ele?.value
                }
            ]
        }
        await DataManagementAPI.deleteTable(bodyData)
            .then(res => {
                if (res.data.status === true) {
                    messageToast('success', res.data?.message);
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(err => {
                messageToast('error', "Internal Server Error");
            })
            .finally(() => setSpinning(false))
    }

    return (
        <div className='container_div'>
            <Helmet>
                <title>SpecOptimzer | Admin</title>
            </Helmet>

            <AdminHeaderTab currrentTab='Data Management' />
            <Spin spinning={spinning}>
                <div className='admin_tab_content_wraper'>
                    <div className='table_head_wraper'>
                        <Text className='table_head' >Table & Data Management</Text>
                    </div>

                    <div className='data_managment_table'>
                        {tableData.length > 0 &&
                            <Table
                                rowKey="table"
                                columns={EMPLOYEE_COLUMNS_HEAD(confirmDelete)}
                                dataSource={tableData}
                                pagination={{
                                    pageSize: 10,
                                    responsive: true,
                                    hideOnSinglePage: true
                                }}
                                className='antdTable'
                                locale={{
                                    emptyText: <TableEmptyContent />,
                                }}
                            />
                        }
                    </div>
                </div>
            </Spin>

            {contextHolder}
        </div>
    )
}

export default DataManagement